import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

// export lazy route
const Accessibility = lazy(() => import("./Accessibility"));

const ACCESSIBILITY_ROUTES: RouteObject[] = [
  {
    path: "/public/accessibility",
    element: React.createElement(Accessibility),
  },
];

export default ACCESSIBILITY_ROUTES;
